import BASE_URL from "../config";

const call = async (path, token, { method = "GET", body } = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/rudraksha${path}`, {
      method,
      headers: {
        ...(body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const result = await response.json().catch(() => ({}));
    return { ok: response.ok, status: response.status, ...result };
  } catch {
    return { ok: false, status: 0, success: false, message: "Network error - please try again." };
  }
};

/* -------------------------------------------------------------- customer */

// The goals for the drop-down (public).
export const getRudrakshaOptions = () => call("/options");

export const calculateRudraksha = (payload, token) =>
  call("/calculate", token, { method: "POST", body: payload });

export const getMyRudrakshaReports = (token) => call("/reports", token);

export const getMyRudrakshaReport = (id, token) => call(`/reports/${id}`, token);

/* ----------------------------------------------------------------- admin */

export const adminGetRudrakshaReports = ({ page = 1, limit = 25, q = "" }, token) =>
  call(`/admin/reports?page=${page}&limit=${limit}${q ? `&q=${encodeURIComponent(q)}` : ""}`, token);
